// Maps engine id → public logo path
const ENGINE_LOGOS = {
  chatgpt:    "/chatgpt.png",
  gemini:     "/Google-Gemini-Logo-Transparent-thumb.png",
  perplexity: "/perplexity-ai-icon-black-logo-png_seeklogo-611679.png",
  copilot:    "/Microsoft-Copilot-Logo-300.webp",
  claude:     "/claude-color.png",
  grok:       "/grok-ai-icon.webp",
  google_sge: "/Google-Gemini-Logo-Transparent-thumb.png",
};

export default ENGINE_LOGOS;
